import { Component, inject, signal, WritableSignal, ChangeDetectionStrategy } from '@angular/core';
import { AppointmentService } from '../../services/appointment.service';
import { Appointment } from '../../models/appointment';
import { AUTH_SERVICE, AuthService } from '../../services/auth.service';
import TYPES from '../../constants/types';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatIcon } from '@angular/material/icon';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-confirm-appointment',
  imports: [
    MatIcon,
    TranslatePipe,
    DatePipe
  ],
  templateUrl: './confirm-appointment.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './confirm-appointment.component.scss',
})
export class ConfirmAppointmentComponent {

  authService: AuthService = inject(AUTH_SERVICE);
  appointmentService: AppointmentService<Appointment> = inject(AppointmentService<Appointment>);
  translate: TranslateService = inject(TranslateService);

  loading: WritableSignal<boolean> = signal<boolean>(false);
  pendingAppointments: WritableSignal<Appointment[]> = signal<Appointment[]>([]);

  snackBar: MatSnackBar = inject(MatSnackBar);

  constructor(){
    this.loadingPendingAppointments();
  }

  loadingPendingAppointments(){
    const userId = this.authService.user()?.id;
    if(userId){
      this.loading.set(true);
      this.appointmentService.getAllPendingAppointmentByUserId(userId).then(
        (data) => {
          this.pendingAppointments.set(data.sort((a,b) => {
            const dateA = new Date(a.date ?? '');
            const dateB = new Date(b.date ?? '');
            return dateA.getTime() - dateB.getTime();
          }));
          this.loading.set(false);
        }
      )
    }
  }

  async accept(item: Appointment){
    if ('vibrate' in navigator) {
      navigator.vibrate(100);
    }

    const itemId = item.id;
    if(itemId){

      this.loading.set(true);

      const { psychologists, users, ...updatedItem } = item;      
      updatedItem.status = TYPES.DATABASE.STATUS.CONFIRMED.code;      
      await this.appointmentService.update(TYPES.DATABASE.TABLES.APPOINTMENTS, itemId, updatedItem);

      this.loadingPendingAppointments();

      const message:string = this.translate.instant('info.appointment_confirmed');
      const action:string = this.translate.instant('buttons.dismiss');
      this.snackBar.open(message, action);
        
    }
  }

  async reject(item: Appointment){
    if ('vibrate' in navigator) {
      navigator.vibrate(100);
    }

    this.loading.set(true);
    
    const itemId = item.id;
    if(itemId){
      const { psychologists, users, ...updatedItem } = item;      
      updatedItem.status = TYPES.DATABASE.STATUS.REJECTED.code;      
      await this.appointmentService.update(TYPES.DATABASE.TABLES.APPOINTMENTS, itemId, updatedItem);

      this.loadingPendingAppointments();

      const message:string = this.translate.instant('info.appointment_rejected');
      const action:string = this.translate.instant('buttons.dismiss');
      this.snackBar.open(message, action);
    }   
  }

  getAppointmentLocalStartEndTime(appointment: Appointment){
    let startTime = '';
    let endTime = '';
    if(appointment.date){
      const date = new Date(appointment.date);

      startTime = date.getHours().toString().padStart(2,'0')
        +':'
        +date.getMinutes().toString().padStart(2,'0');
      if(appointment.duration){
        const endTimeAux = new Date(date.getTime() + appointment.duration * 60 * 1000);
        endTime = endTimeAux.getHours().toString().padStart(2,'0')
          +':'
          +endTimeAux.getMinutes().toString().padStart(2,'0');
      } 
    }
    return startTime + ' - ' + endTime;
  }

}
